module.exports = __webpack_public_path__ + "img/Welcomes.76333998.png";